(ns renolit-roofing-service.util.react-date-range
  (:require [cljc.java-time.format.date-time-formatter :as jt.formatter]
            [cljc.java-time.instant :as jt.instant]
            [cljc.java-time.local-date :as jt.local-date]
            [cljc.java-time.local-time :as jt.local-time]
            [cljc.java-time.zone-id :as jt.zone-id]
            [cljc.java-time.zoned-date-time :as jt.zoned-date-time]
            [renolit-roofing-service.localization :refer [t]]))

(defmulti lib-date->date (fn [date-type _end _lib-date] date-type))
(defmulti date->lib-date (fn [date-type _end _date] date-type))
(defmulti format-date (fn [date-type _end _date] date-type))

(defmethod lib-date->date :local-date
  [_date-type _end lib-date]
  (when lib-date
    (jt.local-date/of (.getFullYear lib-date)
                      (inc (.getMonth lib-date))
                      (.getDate lib-date))))

(defmethod date->lib-date :local-date
  [_date-type _end date]
  (when date
    (let [formatter jt.formatter/iso-local-date]
      (js/Date. (jt.local-date/format formatter date)))))

(defmethod date->lib-date :instant
  [{:keys [zone-id] :or {zone-id (jt.zone-id/system-default)}}
   _end date]
  (when date
    (let [zoned-date-time (jt.instant/at-zone date zone-id)
          formatter jt.formatter/iso-date-time]
      (js/Date. (jt.zoned-date-time/format formatter zoned-date-time)))))

(defmethod lib-date->date :instant
  [{:keys [zone-id] :or {zone-id (jt.zone-id/system-default)}}
   end lib-date]
  (when lib-date
    (let [zoned-date-time (jt.zoned-date-time/of (.getFullYear lib-date)
                                                 (inc (.getMonth lib-date))
                                                 (.getDate lib-date)
                                                 0 0 0 0
                                                 zone-id)]
      (if (= :from end)
        (jt.instant/from zoned-date-time)
        (->> (jt.zoned-date-time/with zoned-date-time jt.local-time/max)
             (jt.instant/from))))))

(defmethod format-date :local-date
  [_date-type _end date]
  (let [formatter (jt.formatter/of-pattern (t [:date-time-formats/local-date]))]
    (jt.formatter/format formatter date)))

(defmethod format-date :instant
  [{:keys [zone-id] :or {zone-id (jt.zone-id/system-default)}} _end date]
  (let [zoned-date-time (jt.instant/at-zone date zone-id)
        formatter (jt.formatter/of-pattern (t [:date-time-formats/local-date]))]
    (jt.zoned-date-time/format formatter zoned-date-time)))

(defn years->threshold-date
  [years]
  (jt.local-date/minus-years (jt.local-date/now) years))

(defn limit-date->lib-limit-date
  [min-date]
  (cond
    (= :today min-date)
    (date->lib-date :local-date :from (jt.local-date/now))))
